import cn from "classnames";
import { Col, Container, Nav, Row, Stack, Tab } from "react-bootstrap";
import styles from "./styles.module.scss";
import { Body, Description, Image, Title } from "@/ui";

export const FeatureTabsList = ({ className, title, description, items, defaultActiveKey, vertical }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={cn(className, styles.featured, { vertical }, "py-5")}>
      <Container className="mw-xl">
        {title && <Title title={title} className="mb-3 text-center" />}
        {description && <Description description={description} className="mb-4 text-center" />}
        <Tab.Container defaultActiveKey={defaultActiveKey}>
          <Stack className={cn({ "flex-row": vertical })}>
            <Nav variant="pills" className={cn({ "flex-column": vertical })}>
              {items.map(({ title, icon }, k) => (
                <Nav.Item key={k} className={cn({ "flex-grow-1": !vertical })}>
                  <Nav.Link eventKey={k} className="p-3 gap-2 d-flex align-items-center">
                    {icon && <Image img={icon} size="75x75" alt={title} />}
                    <Title title={title} tag="h6" className="fw-semibold mb-0" />
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <Tab.Content>
              {items.map(({ body, image }, k) => (
                <Tab.Pane key={k} eventKey={k}>
                  <div className="d-flex justify-content-center align-items-center h-100">
                    {image ? (
                      <Row>
                        <Col xs={12} md={8} className="d-flex justify-content-center align-items-center">
                          <Body body={body} className="text-start p-4" />
                        </Col>
                        <Col xs={12} md={4}>
                          <Image img={image} className="w-100" size="420x" alt="" />
                        </Col>
                      </Row>
                    ) : (
                      <Body body={body} className="text-start p-4" />
                    )}
                  </div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Stack>
        </Tab.Container>
      </Container>
    </div>
  );
};

export default FeatureTabsList;
